module.exports = {
  default: {
    colors: {
      white: '#FFFFFF',
      black: '#000000',
      main: '#000000',
      grey: '#878787',
      lightgrey: '#B6B6B6',
      tablegrey: '#F3F3F3',
      background: '#f7f7f7',
      darkgrey: '#333',
      notWhite: '#F6F6F6',
      beige: '#E9E4E0',
      lightGrey: '#B6B6B6',
      mediumgrey: '#333333',
      notBlack: '#111111',
      turquoise: '#C9D3CE',
      blue: '#759199',
      mediumBlue: '#556F77',
      darkBlue: '#3D4C59',
      orange: '#FF7D20',
      newOrage: '#ef843c',
      red: '#f10404',
      darkRed: '#911827',
      hoverRed: '#720714',
      loadingBar: '#911827',
      highlight: '#911827',
    },
    fontWeights: {
      light: 300,
      regular: 400,
      semibold: 600,
      bold: 700,
      extrabold: 900,
    },
    breakpoints: {
      xs: '20rem',
      sm: '40rem',
      md: '50rem',
      lg: '64rem',
      xl: '80rem',
    },
    fontSizes: [
      '12px',
      '14px',
      '16px',
      '20px',
      '24px',
      '32px',
      '48px',
      '64px',
      '72px',
    ],
    space: [
      '0px',
      '8px',
      '16px',
      '24px',
      '32px',
      '40px',
      '48px',
      '56px',
      '64px',
    ],
    fonts: {
      primary: 'Lato',
    },
  },
};
